<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h660_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="省区"
                  prop="provinceId"
                >
                  <el-select
                    v-if="eventType !== 'view'"
                    v-model="dialogAddEditViewForm.provinceId"
                    filterable
                    clearable
                    placeholder="请选择省区"
                    style="width:100%"
                    @change="changeProvinceFun"
                  >
                    <el-option
                      v-for="item in provinceOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditViewForm.provinceName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="城市"
                  prop="cityId"
                >
                  <el-select
                    v-if="eventType !== 'view'"
                    v-model="dialogAddEditViewForm.cityId"
                    filterable
                    clearable
                    placeholder="请选择城市"
                    style="width:100%"
                    @change="changeCityFun"
                  >
                    <el-option
                      v-for="item in cityOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditViewForm.cityName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="姓名"
                  prop="name"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.name"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="电话"
                  prop="phone"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.phone"
                    :disabled="eventType==='view'"
                    maxlength="11"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="人员类型">
                  <el-radio-group
                    v-model="dialogAddEditViewForm.type"
                    :disabled="eventType==='view'"
                  >
                    <el-radio :label="1">
                      礼仪
                    </el-radio>
                    <el-radio :label="2">
                      主持人
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="身份证号"
                  prop="idCard"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.idCard"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="身份证有效截止日期"
                  prop="idEndDate"
                >
                  <el-date-picker
                    v-model="dialogAddEditViewForm.idEndDate"
                    type="date"
                    style="width: 100%;"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :disabled="eventType === 'view'"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="人员类别">
                  <el-radio-group
                    v-model="dialogAddEditViewForm.sort"
                    :disabled="eventType==='view'"
                  >
                    <el-radio :label="1">
                      直聘
                    </el-radio>
                    <el-radio :label="2">
                      三方公司
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  label="身份证号码头像面"
                  required
                >
                  <el-upload
                    v-if="eventType !== 'view'"
                    ref="picUpload"
                    list-type="picture-card"
                    :action="picUploadAction"
                    :data="picData"
                    :before-upload="beforeAvatarUpload"
                    :file-list="initFileList"
                    :on-preview="handlePictureCardPreview"
                    :headers="{'X-Token': getToken()}"
                    :multiple="false"
                    :limit="1"
                    accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
                    :with-credentials="true"
                    :on-success="function (res, file, fileList) {return handleSuccess (res, file, fileList, picList)}"
                    :on-remove="(file,fileList)=>handlePictureCardRemove(file,fileList,picList)"
                    :on-exceed="handleExceed"
                  >
                    <el-button
                      type="primary"
                      class="upload-button"
                    >
                      选择图片
                    </el-button>
                  </el-upload>
                  <show-preview
                    v-else
                    :arr-file-data="picList"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="身份证国徽面"
                  required
                >
                  <el-upload
                    v-if="eventType !== 'view'"
                    ref="picUpload2"
                    list-type="picture-card"
                    :action="picUploadAction"
                    :data="picData2"
                    :before-upload="beforeAvatarUpload"
                    :file-list="initFileList2"
                    :on-preview="handlePictureCardPreview"
                    :headers="{'X-Token': getToken()}"
                    :multiple="false"
                    :limit="1"
                    accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
                    :with-credentials="true"
                    :on-success="function (res, file, fileList) {return handleSuccess (res, file, fileList, picList2)}"
                    :on-remove="(file,fileList)=>handlePictureCardRemove(file,fileList,picList2)"
                    :on-exceed="handleExceed"
                  >
                    <el-button
                      type="primary"
                      class="upload-button"
                    >
                      选择图片
                    </el-button>
                  </el-upload>
                  <show-preview
                    v-else
                    :arr-file-data="picList2"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="开户行"
                  prop="bankName"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.bankName"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="银行账号"
                  prop="bankNo"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.bankNo"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    placeholder="备注"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>

      <el-dialog
        :visible.sync="dialogImageVisible"
        append-to-body
      >
        <img
          width="100%"
          :src="dialogImageUrl"
          alt=""
        >
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
// dialog拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// TOKEN
import { getToken } from "@/utils/auth"
// 表单验证
import { validateForm } from '@/utils/validateForm'
// 图片预览
import showPreview from '@/components/showPreview'
// 区域API
import { listAreaApi } from '@/api/v2/area';
// 外聘人员API
import { saveExternalEmployeeApi, viewExternalEmployeeApi } from '@/api/v2/externalEmployee';
import { deleteFileApi } from '@/api/common'

export default {
  components: { showPreview },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        provinceId: [{ required: true, message: '请选择省区', trigger: 'change' }],
        cityId: [{ required: true, message: '请选择城市', trigger: 'change' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入电话', trigger: 'blur' }],
        type: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
        idCard: [{ required: true, message: '请输入身份证号', trigger: 'blur' }, { validator: validateForm.validateIdCard, trigger: 'blur' }],
        idEndDate: [{ required: true, message: '请选择身份证有效截止日期', trigger: 'change' }],
        bankName: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }],
        bankNo: [{ max: 64, message: '最多输入64个字符', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      provinceOptions: [],
      cityOptions: [],
      //上传相关
      baseUrl: process.env.VUE_APP_BASE_API,
      picData: { directory: 'externalEmployee', type: 1 },
      picData2: { directory: 'externalEmployee', type: 0 },
      picUploadAction: '',
      initFileList: [],
      initFileList2: [],
      dialogImageUrl: '',
      dialogImageVisible: false,
      picList: [], // 照片对象数组
      picList2: [], // 照片对象数组

    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.picUploadAction = process.env.VUE_APP_BASE_API + '/web/common/uploadIdCardFile'
        _this.picList = []
        _this.initFileList = []
        _this.picList2 = []
        _this.initFileList2 = []
        _this.provinceOptions = []
        _this.cityOptions = []
        _this.dialogAddEditViewForm = {
          provinceId: null,
          provinceName: '',
          cityId: null,
          cityName: '',
          name: '',
          phone: '',
          bankName: '',
          bankNo: '',
          idCard: '',
          idEndDate: '',
          type: 1,
          sort: 2,
          sex: 0,
          remark: ''
        }
        if (_this.eventType !== 'view') {
          _this.loadProvinceData()
        }
        if (_this.eventType !== 'add') {
          _this.loadExternalEmployeeData()
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    getToken,
    // 加载数据
    loadExternalEmployeeData () {
      let _this = this;
      viewExternalEmployeeApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        for (let key in _this.dialogAddEditViewForm) {
          _this.dialogAddEditViewForm[key] = data[key]
        }
        _this.dialogAddEditViewForm.idImgUrl1 = data.idImgUrl1
        _this.dialogAddEditViewForm.idImgUrl2 = data.idImgUrl2
        _this.dialogAddEditViewForm.id = data.id
        if (_this.eventType !== 'view') {
          _this.loadCityData(data.provinceId)
        }

        if (_this.dialogAddEditViewForm.idImgUrl1 && this.dialogAddEditViewForm.idImgUrl1.length > 0) {
          let fileUrl = _this.dialogAddEditViewForm.idImgUrl1
          if (fileUrl.startsWith('/upload')) {
            fileUrl = process.env.VUE_APP_FILE_V2_API + fileUrl;
          } else if (fileUrl.startsWith('upload')) {
            fileUrl = process.env.VUE_APP_FILE_V2_API + '/' + fileUrl;
          }
          let obj = {}
          obj.name = _this.dialogAddEditViewForm.idImgUrl1
          obj.url = fileUrl
          obj.attachmentName = _this.dialogAddEditViewForm.idImgUrl1
          obj.attachmentUrl = _this.dialogAddEditViewForm.idImgUrl1
          _this.picList.push(obj)
          _this.initFileList.push(obj)
        }
        if (_this.dialogAddEditViewForm.idImgUrl2 && _this.dialogAddEditViewForm.idImgUrl2.length > 0) {
          let fileUrl = _this.dialogAddEditViewForm.idImgUrl2
          if (fileUrl.startsWith('/upload')) {
            fileUrl = process.env.VUE_APP_FILE_V2_API + fileUrl;
          } else if (fileUrl.startsWith('upload')) {
            fileUrl = process.env.VUE_APP_FILE_V2_API + '/' + fileUrl;
          }
          let obj = {}
          obj.name = _this.dialogAddEditViewForm.idImgUrl2
          obj.url = fileUrl
          obj.attachmentName = _this.dialogAddEditViewForm.idImgUrl2
          obj.attachmentUrl = _this.dialogAddEditViewForm.idImgUrl2
          _this.picList2.push(obj)
          _this.initFileList2.push(obj)
        }
      })
    },
    // 初始省区下拉数据
    loadProvinceData () {
      listAreaApi({ parentId: 1, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择省区回调
    changeProvinceFun (val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.provinceOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditViewForm.provinceName = selectItem ? selectItem.label : ''
      _this.cityOptions = []
      _this.dialogAddEditViewForm.cityId = null
      _this.dialogAddEditViewForm.cityName = ''
      _this.loadCityData(val)
    },
    // 初始城市下拉数据
    loadCityData (val) {
      if (val === null || val === '') return;
      listAreaApi({ parentId: val, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.cityOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择城市回调
    changeCityFun (val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.cityOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditViewForm.cityName = selectItem ? selectItem.label : ''
    },
    // 图片上传前
    beforeAvatarUpload (file) {
      const isLt5M = file.size / 1024 / 1024 < 10
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过10MB!')
        return false
      }
      this.isUploading = true
    },
    // 超过限制
    // eslint-disable-next-line no-unused-vars
    handleExceed (files, fileList) {
      this.$message.error('只能上传一张照片!')
      return false
    },
    // 预览
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogImageVisible = true
    },
    // 上传成功
    handleSuccess (res, file, fileList, dataObj) {
      if (res.mark === '200') {
        let fileObj = {}
        fileObj.attachmentName = res.myFileName
        fileObj.attachmentUrl = res.fileName
        fileObj.url = this.baseUrl + res.fileName
        dataObj.push(fileObj)
        if (res.idCardNo) {
          this.dialogAddEditViewForm.idCard = res.idCardNo
        }
        if (res.idEndDate) {
          this.dialogAddEditViewForm.idEndDate = res.idEndDate
        }
        this.isUploading = false
      } else {
        this.$message.error(res.message)
      }
    },
    // 删除
    handlePictureCardRemove (file, fileList, dataObj) {
      let fileUrl = ''
      if (file.response) {
        let resData = file.response
        let delIndex = dataObj.findIndex(item => {
          return item.attachmentUrl === resData.fileName
        })
        fileUrl = resData.fileName
        dataObj.splice(delIndex, 1)
      } else {
        let delIndex = dataObj.findIndex(item => {
          if (item.url === file.url) {
            fileUrl = item.attachmentUrl
            return item.url === file.url
          }
        })
        dataObj.splice(delIndex, 1)
      }
      if (fileUrl !== '') {
        deleteFileApi({ filePath: fileUrl }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
          }
        })
      }
    },

    // 新增|修改保存
    handleSave () {
      let _this = this;
      _this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          if (_this.picList.length < 1) {
            _this.$message({ message: '请上传身份证号码头像面', type: 'warning' })
            return
          }
          if (_this.picList2.length < 1) {
            _this.$message({ message: '请上传身份证国徽面', type: 'warning' })
            return
          }
          let sexNum = String(_this.dialogAddEditViewForm.idCard).substring(16, 17)
          if (sexNum % 2 === 0) {
            _this.dialogAddEditViewForm.sex = 2
          } else {
            _this.dialogAddEditViewForm.sex = 1
          }
          _this.$confirm(
            (_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '外聘人员', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {

              if (this.picList.length > 0) {
                this.dialogAddEditViewForm.idImgUrl1 = this.picList[0].attachmentUrl
              } else {
                this.dialogAddEditViewForm.idImgUrl1 = ''
              }
              if (this.picList2.length > 0) {
                this.dialogAddEditViewForm.idImgUrl2 = this.picList2[0].attachmentUrl
              } else {
                this.dialogAddEditViewForm.idImgUrl2 = ''
              }
              saveExternalEmployeeApi(_this.dialogAddEditViewForm).then(() => {
                _this.$message({ message: '保存成功', type: 'success' })
                _this.$emit('reloadData')
                _this.modalClose()
              }).catch(() => { })
            }).catch(() => { })
        }
      })
    },
    modalClose () {
      this.$emit('update:dialogVisible', false)
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
  }
}
</script>
<style lang="scss"  scoped>
</style>
